'use client';

import React from 'react';

export type SortOption = {
  label: string;
  value: string;
};

export type ProductOrderSectionProps = {
  title: string;
  options: SortOption[];
  selectedValue: string;
  onChange: (value: string) => void;
  className?: string;
};

const ProductOrderSection: React.FC<ProductOrderSectionProps> = ({ title, options, selectedValue, onChange, className = '' }) => {
  return (
    <div className={`${className}`}>
      <h3 className="font-semibold text-gray-900 mb-3">{title}</h3>

      <div className="space-y-2">
        {options.map((option) => {
          const selected = selectedValue === option.value;
          const inputId = `order-${option.value}`;

          return (
            <label key={option.value} htmlFor={inputId} className="flex items-center space-x-2 cursor-pointer group hover:bg-gray-50 p-2 rounded-md">
              <input
                id={inputId}
                type="radio"
                name="order-section"
                checked={selected}
                onChange={() => onChange(option.value)}
                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2"
              />
              <span className={`text-sm ${selected ? 'font-medium text-gray-900' : 'text-gray-700'}`}>{option.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default ProductOrderSection;
